import React, { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { Container, Box, Button } from '@material-ui/core';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

// utils
import useWindowSize from 'utils/useWindowSize';

const PdfViewer = (props) => {
    const [pageNumber, setNumPages] = useState(1);
    const [pageAllNumber, setAllPages] = useState(0);
    const { sizes } = useWindowSize();

    function onLoadSuccess({ numPages }) {
        setAllPages(numPages);
    }

    function handlePrevClick() {
        const count = pageNumber - 1 < 1 ? 1 : pageNumber - 1;
        setNumPages(count);
    }

    function handleNextClick() {
        const count = pageNumber + 1 > pageAllNumber ? pageAllNumber : pageNumber + 1;
        setNumPages(count);
    }

    return (
        <Container
            maxWidth="lg"
            fullWidth={true}
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
            }}
        >
            <Box>
                <Document loading="Ачаалж байна..." file={props.url} onLoadSuccess={onLoadSuccess}>
                    <Page pageNumber={pageNumber} width={sizes.sm ? 340 : 900} />
                </Document>
            </Box>
            <Box style={{ marginTop: 20 }}>
                <Button onClick={handlePrevClick}>Өмнөх</Button>
                <Button onClick={handleNextClick}>Дараах</Button>
            </Box>
        </Container>
    );
};

PdfViewer.defaultProps = {
    width: 600,
    height: 300,
};

export default PdfViewer;
